import { CircularProgress, Divider, styled } from '@mui/material';
import HiringTeam from './components/HiringTeam';
import ScorecardSection from './components/ScorecardSection';
import auth from 'utils/auth';
import { JobClosureNotificationSection } from './components/JobClosureNotifications';
import { useQueryGetHiringTeamData } from './queries';
import { getAxiosErrorMessageByStatusCode } from 'hooks/errorHandling/errorHandlingHooks';
import { Alert } from 'sharedComponents/Alert';
import { ATSTabbedJobViewHiringTabTestIds } from 'data-testids/ATS';

const HiringTeamTab: React.FC<{ jobId: number }> = ({ jobId }) => {
  const isAtsLiteDistrict = auth.isAtsLiteDistrict();
  const { isError, data, error, isLoading } = useQueryGetHiringTeamData(jobId, !isAtsLiteDistrict);
  const errorMessage = getAxiosErrorMessageByStatusCode(error);

  if (isError) {
    return (
      <Alert dataTestId={ATSTabbedJobViewHiringTabTestIds.HIRING_TEAM_ALERT} type="error">
        {errorMessage ?? 'Something went wrong'}
      </Alert>
    );
  }

  if (isAtsLiteDistrict) {
    return <ScorecardSection jobId={jobId} />;
  }

  return (
    <>
      {isLoading && !data ? (
        <CircularProgress />
      ) : (
        <>
          <HiringTeam jobId={jobId} />
          <SectionDivider />
          <ScorecardSection jobId={jobId} />
          {auth.isDistrictAdmin() && (
            <>
              <SectionDivider />
              <JobClosureNotificationSection jobId={jobId} />
            </>
          )}
        </>
      )}
    </>
  );
};

export default HiringTeamTab;

const SectionDivider = styled(Divider)(({ theme }) => ({
  margin: `${theme.spacing(4)} 0`,
}));
